<template>
    <div class="notice">
        <el-scrollbar style="height: 100vh;">
            <div class="cont" v-html="noticeData"></div>
            <div class="checkedConfirm">
                <el-checkbox v-model="checkedConfirm">确认告知书</el-checkbox>
            </div>
            <div class="btnConfirm">
                <el-button type="success" :disabled="!checkedConfirm"  @click="btnConfirm">确认告知书</el-button>
            </div>
        </el-scrollbar> 
    </div>
</template>

<script>
import {patch, studentNotification} from '@/api/login';
export default {
    name: 'notice',
    data(){
        return {
            noticeData: '',
            checkedConfirm: true,
            first_login_verify: this.$route.query.first_login_verify,
        };
    },
    created(){
        this.getData();
    },
    methods: {
        async getData(){
            let res = await patch();
            if(res.code == 200){
                let {result} = res;
                this.noticeData = result.notification.content;
            }
        },
        // 点击按钮
        async btnConfirm(){
            await studentNotification();
            if (this.first_login_verify === 0) {
                this.$router.push("/upDataIDQr");
                return;
            }
            this.$router.replace({
                path: "home",
            });
        },
    },
};
</script>

<style lang="scss">
// #app{
//     overflow: visible;
//     overflow-x: auto;
// }
.notice{
    .el-checkbox__input.is-checked .el-checkbox__inner{
        background-color: #0BA750;
        border-color: #0BA750;
    }
    .el-checkbox__inner:hover{
        border-color: #0BA750;
    }
    .el-checkbox__input.is-focus .el-checkbox__inner{
        border-color: #0BA750;
    }
    .el-checkbox__input.is-checked+.el-checkbox__label{
        color: #0BA750;
    }
}
</style>

<style lang="scss" scoped>
.notice{
    .cont{
        width: 1200px;
        margin: 20px auto;
    }
    .checkedConfirm{
        margin-top: 20px;
        text-align: center;
    }
    .btnConfirm{
        margin-top: 20px;
        display: flex;
        justify-content: center;
    }
}
</style>